angular.module('rasService', ['constants'])
.factory('rasService', function($http, $q, myConfig) {

  var service = {};

  var _baseUrl = myConfig.apiUrl + 'rings/'; //'http://127.0.0.1:8000/v1/rings/';

  /*
  * send oblist
  */
  service.getRasMatrix = function(proj, from, to){
    var tableName = 'vw_rasmatrix';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName + "?proj="+proj+"&from="+from+"&to="+to;
    // send
    $http({
      method  : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * insert Ras project
  */
  service.insertRasProject = function(data){
    var tableName = 'rasprojects';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method  :'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  } 

  /*
  * get ces matrix
  */
  service.getCesMatrix = function(proj, year){
    var tableName = 'vw_cesmatrix';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName + "?proj="+proj+"&year="+year;
    // send
    $http({
      method : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get ces items
  */
  service.getCesItems = function(additionalUrl){
    var tableName = 'vw_ces_items';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    if (additionalUrl){
      url += additionalUrl;
    }
    // send
    $http({
      method : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get ces items
  */
  service.getRasItems = function(additionalUrl){
    var tableName = 'vw_ras_items';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    if (additionalUrl){
      url += additionalUrl;
    }
    // send
    $http({
      method : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }


  /*
  * get ras projects
  */
  service.getRasProjects = function(additionalUrl){
    var tableName = 'rasprojects';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    if (additionalUrl){
      url += additionalUrl;
    }
    // send
    $http({
      method : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get ras projects
  */
  service.getCesProjects = function(additionalUrl){
    var tableName = 'cesprojects';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    if (additionalUrl){
      url += additionalUrl;
    }
    // send
    $http({
      method : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  return service;

});
